import React from 'react';
import { isAuthorized } from '../helpers/auth-roles';

export default function AuthHideShow({ permissions, children }) {
  const show = permissions ? isAuthorized(permissions) : true;
  if (show) return <>{children}</>;
  return <></>;
}
